import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import VuejsDialog from 'vuejs-dialog'
import VuejsDialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'
import InputError from '@/components/InputError.vue'
import vueSelect from 'vue-select'
import VueCropper from 'vue-cropper'

import {
    FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'
import {
    library
} from '@fortawesome/fontawesome-svg-core'

// solid
import {
    faHeart,
    faClock,
    faPlus,
    faSearch,
    faSync,
    faSlidersH,
    faUser,
    faUsers,
    faChevronLeft,
    faChevronRight,
    faDownload,
    faCalendar,
    faComment,
    faStore,
    faCogs,
    faShippingFast,
    faShieldAlt,
    faTimesCircle,
    faCopy,
    faTrashAlt,
    faFileInvoiceDollar,
    faCamera,
    faRobot,
    faCaretDown,
    faShoppingCart,

    faReply,
    faShare,
    faBold,
    faItalic,
    faStrikethrough,
    faUnderline,
    faCode,
    faParagraph,
    faHeading,
    faListUl,
    faListOl,
    faTasks,
    faDotCircle,
    faQuoteRight,
    faPhotoVideo,
    faCheckSquare,
    faExternalLinkAlt,
    faLink,
    faLaugh,
    faFrown,
    faQuestionCircle,

    faChevronCircleUp,
    faChevronCircleDown,
} from '@fortawesome/free-solid-svg-icons'
import {
    faHeart as farHeart,
} from '@fortawesome/free-regular-svg-icons'
import {
    faFacebookSquare,
    faTwitter,
} from '@fortawesome/free-brands-svg-icons'
import {
    faExternalLink,
    faUsersClass,
    faBallotCheck,
    faChevronDoubleLeft,
    faChevronDoubleRight,
    faInventory,
    faBoxFull,
    faSignOut,

    faH1,
    faH2,
    faH3,
//    faH4,
    faText,
} from '@fortawesome/pro-solid-svg-icons'
import {
    faCommentAltLines,
} from '@fortawesome/pro-regular-svg-icons'

library.add(
    // free-solid
    faHeart,
    faClock,
    faPlus,
    faSearch,
    faSlidersH,
    faSync,
    faUser,
    faUsers,
    faChevronLeft,
    faChevronRight,
    faDownload,
    faCalendar,
    faComment,
    faStore,
    faCogs,
    faShippingFast,
    faShieldAlt,
    faTimesCircle,
    faCopy,
    faTrashAlt,
    faFileInvoiceDollar,
    faCamera,
    faRobot,
    faCaretDown,
    faShoppingCart,

    faReply,
    faShare,
    faBold,
    faItalic,
    faStrikethrough,
    faUnderline,
    faCode,
    faParagraph,
    faHeading,
    faListUl,
    faListOl,
    faTasks,
    faDotCircle,
    faQuoteRight,
    faPhotoVideo,
    faCheckSquare,
    faExternalLinkAlt,
    faLink,
    faLaugh,
    faFrown,
    faQuestionCircle,

    faChevronCircleUp,
    faChevronCircleDown,

    // free-regular
    farHeart,

    // free-brands
    faFacebookSquare,
    faTwitter,

    // pro-solid
    faExternalLink,
    faUsersClass,
    faBallotCheck,
    faText,
    faChevronDoubleLeft,
    faChevronDoubleRight,
    faInventory,
    faBoxFull,
    faSignOut,

    faH1,
    faH2,
    faH3,
//    faH4,

    // pro-regular
    faCommentAltLines
)

Vue.component('vue-select', vueSelect)
Vue.component('vue-cropper', VueCropper)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(VuejsDialog)
Vue.component('InputError', InputError)

const requireComponent = require.context(
    './',
    false,
    /Base[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
    const componentConfig = requireComponent(fileName)

    const componentName = upperFirst(
        camelCase(
            fileName
                .split('/')
                .pop()
                .replace(/\.\w+$/, '')
        )
    )

    Vue.component(
        componentName,
        componentConfig.default || componentConfig
    )
})
